/**
 * Nafaka alacak kaleminde iki tutar vardır:
 *
 *   `tutar`               = TAKİPTE BAZ ALINAN tutar — her alacak türünde olduğu gibi.
 *                           Formdaki "Talep Edilen Nafaka Tutarı".
 *   `aylik_nafaka_tutari` = "Aylık Nafaka Tutarı". API'de NULL ise aylık = `tutar` demektir:
 *                           talep edilen ayrıca girilmemiş, taban aylığı İZLİYOR.
 *
 * Evrak, kapak hesabı, liste gibi görüntü katmanları yalnız `tutar` okur ve hiçbir özel
 * kural bilmek zorunda değildir. Bu ayrımı bilen tek yer nafaka kalemi formudur; aşağıdaki
 * iki fonksiyon o formun API şekli ile ekran şekli arasındaki çevirisidir.
 */

interface NafakaTutarlari {
    tutar?: number | string | null;
    aylik_nafaka_tutari?: number | string | null;
    // EMEKLİ alan: yalnız swap migration'ını henüz koşmamış kiracının satırında dolu gelir.
    talep_edilen_nafaka_tutari?: number | string | null;
}

interface NafakaFormTutarlari {
    tutar: any;
    aylik_nafaka_tutari: any;
    talep_edilen_nafaka_tutari: null;
}

function bos(deger: unknown): boolean {
    return deger === null || deger === undefined || deger === "";
}

/**
 * Kayıtlı kalemi forma açarken: taban aylığı izliyorsa (aylik_nafaka_tutari boş) tutar
 * "Aylık" kutusuna taşınır, "Talep Edilen" kutusu BOŞ gösterilir.
 *
 * Boş göstermek şart: kutu `tutar` ile dolu açılsaydı kullanıcı yalnız aylık tutarı
 * değiştirdiğinde eski değer "talep edilen" olarak geri yazılır, takip tabanı sessizce
 * eski tutarda kalırdı. Boş bırakılan talep edileni backend aylıktan doldurur
 * (AlacakKalemiObserver::saving) ve taban aylıkla birlikte değişir.
 *
 * Formun yerel durumu HER ZAMAN yeni modeldedir; emekli `talep_edilen_nafaka_tutari` boşaltılır.
 * Migration'ı bekleyen kiracıda satır 2026-04 modelinde gelir (`tutar` = aylık, taban
 * talep_edilen'de) ve kutular yine doğru dolar; kaydederken kolonu olmayan kiracıya yazımı
 * backend kendisi o modele uyarlar (AlacakKalemiObserver::saving).
 */
export function nafakaTutarlariniFormaAyir(kalem: NafakaTutarlari): NafakaFormTutarlari {
    if (!bos(kalem.talep_edilen_nafaka_tutari)) {
        return {tutar: kalem.talep_edilen_nafaka_tutari, aylik_nafaka_tutari: kalem.tutar, talep_edilen_nafaka_tutari: null};
    }
    if (bos(kalem.aylik_nafaka_tutari) && !bos(kalem.tutar)) {
        return {tutar: null, aylik_nafaka_tutari: kalem.tutar, talep_edilen_nafaka_tutari: null};
    }
    return {tutar: kalem.tutar, aylik_nafaka_tutari: kalem.aylik_nafaka_tutari, talep_edilen_nafaka_tutari: null};
}

/**
 * Henüz kaydedilmemiş (takip ekleme sihirbazındaki) kalemin listede gösterilecek tabanı.
 * Kayıtlı kalemde `tutar` her zaman doludur; kaydedilmemiş kalemde talep edilen boş
 * bırakılmışsa taban aylık tutardır.
 */
export function nafakaTabanTutari(kalem: NafakaTutarlari): any {
    return bos(kalem.tutar) ? kalem.aylik_nafaka_tutari : kalem.tutar;
}
